// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__33IWE","header":"ReportDetails_header__3HpfE","title":"ReportDetails_title__3SbhW","left":"ReportDetails_left__34uO6"};